import {
  Component,
  Injectable,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  TemplateRef,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from '../../../../../common/services/Group.service';
import { Select2TemplateFunction, Select2OptionData } from 'ng2-select2';
import { OrganizeService } from '../../../../../common/services/Organize.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { UserService } from '../../../../../common/services/User.service';
import * as _ from 'lodash';
import { FieldService } from '../../../../../common/services/Field.service';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { SocketService } from '../../../../../common/services/Socket.service';
import { CommentService } from '../../../../../common/services/Comment.service';
import { UtilityService } from 'app/common/services/Utility.service';
import { BaseComponent } from '../../../../../components/base.component';

declare var $: any;
declare const Timer: any;

@Component({
  moduleId: module.id,
  selector: 'detail-organize',
  templateUrl: './detail_organize.component.html',
  styleUrls: ['../detail.css', './organize.css'],
  providers: [
    BsModalService,
    GroupService,
    OrganizeService,
    EvsAddressService,
    UserService,
    FieldService,
    CommentService,
  ],
})
@Injectable()
export class DetailOrganizeComponent extends BaseComponent implements AfterViewInit {
  @Input() organize;
  public no_image: any = 'assets/images/contact.png';

  @Output('comeback') comeback = new EventEmitter();
  public allStatus: any = [];
  public status_select2: any = [{ id: '', text: '' }];
  public fields: any = [];

  public change_name = false;
  public tab = 'ticket';

  public tickets: any = {};
  public currentPage: any = {};
  public totalItem: any = {};
  public totalPage: any = {};
  public page_size = 10;
  public is_loading = false;
  public filter_type: any = 'request'; // request | assign || reciver
  public total = 0;

  public selected: any = {};
  public fast_status: any;

  public modelFilter: any = {};
  public detailTicket: any = {};

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private groupService: GroupService,
    private organizeService: OrganizeService,
    private addressService: EvsAddressService,
    private userService: UserService,
    private fieldService: FieldService,
    private ticketService: TicketService,
    private socketService: SocketService,
    private commentService: CommentService
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(
      function () {
        if (this.organize.tags && typeof this.organize.tags == 'object') {
          this.organize.tags_string = this.organize.tags.join(',');
        } else {
          this.organize.tags_string = this.organize.tags;
        }
        this.model = _.assign({}, this.organize);
        if (this.model.tags_string && typeof this.model.tags_string == 'string') {
          let arr_tags = this.model.tags_string.split(',');
          arr_tags = _.map(arr_tags, e => {
            return {
              displayValue: e,
            };
          });
          this.model.tags = arr_tags;
        } else {
          this.model['tags'] = [];
        }
      }.bind(this),
      200
    );
  }

  changeTab(tab) {
    this.tab = tab;
  }
  openUser(user) {
    this.socketService.opentab(user, 'user', 'edit');
  }

  hover(item) {
    this.detailTicket = item;
    this.commentService
      .list({
        where: JSON.stringify({ ticket_id: this.detailTicket._id }),
        limit: 1,
      })
      .subscribe(res => {
        if (res.status == 200 && res.error == false && res.data.comments) {
          this.detailTicket['lastest_comment'] = res.data.comments[0] ? res.data.comments[0] : null;
        }
      });
  }

  changeFastStatus(e: any) {
    this.fast_status = e.value;
  }

  submitFastStatus() {
    const ids = [];
    this.allStatus.forEach(status => {
      if (this.tickets[status.id]) {
        this.tickets[status.id].forEach(e => {
          if (this.selected[status.id][e._id]) {
            ids.push(e._id);
          }
        });
      }
    });
    this.ticketService.updateMany({ _id: { $in: ids } }, { status: parseInt(this.fast_status) }).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Chuyển trạng thái không thành công',
            };
            this.toastr.error('Chuyển trạng thái không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Chuyển trạng thái thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.modalRef.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  changedFilterGroup(e) {
    this.modelFilter.group_id = e.value;
  }

  filterAgent() {
    const options = [];
    if (this.modelFilter.filter_agent_phone) {
      options.push({
        key: 'phone',
        condition: '=',
        value: this.modelFilter.filter_agent_phone,
      });
    }
    if (this.modelFilter.group_id) {
      options.push({
        key: 'group_id',
        condition: '=',
        value: this.modelFilter.group_id,
      });
    }
  }

  updateOrganize(body) {
    this.organizeService.update(this.organize.organize_id, body).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.throwSuccess('Cập nhật thành công!');
          this.comeback.emit({
            organize_id: this.organize.organize_id,
          });
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  openTicket(ticket: any) {
    this.userService
      .find({ _id: ticket.requester_id })
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          ticket.request = res.data;
          this.socketService.opentab(ticket, 'ticket', 'edit');
        }
      });
  }

  newTicket() {
    this.socketService.opentab({}, 'ticket', 'new');
  }

  execCall(phone) {
    if (UtilityService.isValidPhoneNumber(phone)) {
      this.socketService.execCall(phone);
    } else {
      this.toastr.error('', 'Số điện thoại không hợp lệ', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  changedName() {
    if (this.model.name) {
      this.model.name = this.model.name.trim();
    }
    this.updateOrganize({ name: this.model.name });
  }

  changedDomain() {
    const name = this.model.name ? this.model.name.trim() : '';
    this.updateOrganize({ domain: this.model.domain, name: name });
  }

  addTags() {
    const name = this.model.name ? this.model.name.trim() : '';
    const _tags_arr = [];
    this.model.tags.forEach(t => {
      _tags_arr.push(t.displayValue);
    });
    const _tags = _tags_arr.length > 0 ? _tags_arr.join(',') : null;
    this.updateOrganize({ tags: _tags, name: name });
  }

  changedNote() {
    const name = this.model.name ? this.model.name.trim() : '';
    if (this.model.note && this.model.note.trim() != '') {
      this.updateOrganize({ note: this.model.note.trim(), name: name });
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/organize/detail_organize.component.ts